
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_70_43777)","fill":"#7B61FF"}},[_c('path',{attrs:{"d":"M16.61 2.95l1.06.373.352 1.058a.418.418 0 00.791 0l.351-1.053 1.053-.35a.417.417 0 000-.79l-1.053-.351-.35-1.053c-.115-.34-.677-.34-.792 0l-.349 1.048-1.046.327a.416.416 0 00-.016.79zM20.24 16.362l-2.215-.886-.886-2.215c-.125-.317-.648-.317-.774 0l-.885 2.21-2.209.837a.418.418 0 00-.014.773l2.22.936.888 2.219a.415.415 0 00.774 0l.886-2.215 2.215-.886a.416.416 0 000-.773zm-2.691.952a.415.415 0 00-.232.233l-.566 1.413-.566-1.413a.413.413 0 00-.225-.23l-1.42-.599 1.406-.532a.417.417 0 00.24-.235l.565-1.413.566 1.413c.043.106.126.19.232.232l1.413.566-1.413.565zM16.28 10.884c.538-.172.887-.65.887-1.216a1.26 1.26 0 00-.898-1.219l-4.805-1.41-1.399-4.799a1.257 1.257 0 00-1.204-.904c-.555.023-1.048.335-1.233.886L6.204 7.038l-4.8 1.4A1.257 1.257 0 00.5 9.642a1.263 1.263 0 00.886 1.232l4.818 1.424 1.414 4.817c.172.54.65.888 1.215.888a1.26 1.26 0 001.22-.898l1.41-4.806 4.806-1.41.01-.003v-.002zm-.25-.795l-5.019 1.474a.416.416 0 00-.282.282L9.257 16.86a.43.43 0 01-.423.308.426.426 0 01-.419-.298L6.94 11.846a.417.417 0 00-.282-.283l-5.02-1.484a.43.43 0 01-.303-.426c.001-.076.027-.331.31-.417l5.013-1.46a.415.415 0 00.284-.283l1.484-5.02a.43.43 0 01.42-.303h.006c.076 0 .33.027.416.31l1.461 5.013c.04.136.146.243.283.283l5.015 1.472a.43.43 0 01.308.422.429.429 0 01-.304.42h-.002z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_70_43777"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    